const Benefits = () => {
  return (
    <div>
      <h1>Benefícios</h1>
    </div>
  );
};

export default Benefits;
